import * as yup from 'yup'

export const schema = yup.object().shape({
  justification: yup
    .string()
    .required('A justificativa é obrigatória')
    .min(10, 'A justificativa deve ter pelo menos 10 caracteres'),
  attachments: yup.mixed().fileUpload({
    sizeLimit: 5,
    required: true,
  }),
})

export default schema
